<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-image-docs-preview></ui-image-docs-preview></p>
<h1 id="description">Description</h1>
<p>Image used to show image circle component </p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-image</span> [<span class="hljs-attr">image</span>]=<span class="hljs-string">"imageUrl"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">image</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-image</span>
 [<span class="hljs-attr">image</span>]=<span class="hljs-string">"imageUrl"</span> <span class="hljs-attr">bordered</span>=<span class="hljs-string">"true"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-image</span>&gt;</span>
</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
